export default __webpack_public_path__ + "static/media/OneLogin.be3f7163.md";